var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"vue-outage-sparkline-wrap"},[(_vm.loadingSparklineData)?_c('b-spinner',{staticClass:"spinner"}):_vm._e(),(_vm.chartVisible && _vm.chartData.series && _vm.chartData.series.length)?_c('zingchart',{attrs:{"data":_vm.chartData},on:{"complete":_vm.chartCompleted}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }